// extracted by mini-css-extract-plugin
export default {"wrapper":"BadgeDetails_wrapper__4lRMr","container":"BadgeDetails_container__E+4ZO","textWrapper":"BadgeDetails_textWrapper__9WxFX"};